import React, { useEffect, useState } from "react";
import { Grid, MenuItem, TextField } from "@mui/material";
import moment from "moment/moment";

import { getToken } from "../../../../api/Account";
import { addBonoAsync, getTiposBonoAsync } from "../../../../api/Employees";
import { EstadoError, useAviso } from "../../../../components/base";
import {
  CampoFecha,
  CampoMonto,
  DialogoFormulario,
  esMontoEscribible,
  fechaCambiada,
  useCargaLocal,
  useEnvio,
  useEscritura,
} from "../comunes";

const AddBono = ({ id, setShowModal, reload, setReload }) => {
  const [desde, setDesde] = useState(new Date());
  const [hasta, setHasta] = useState(new Date());

  const [tipoBonoList, setTipoBonoList] = useState([]);
  const [selectedTBono, setSelectedTBono] = useState("");

  const [monto, setMonto] = useState("");
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();
  const { cargando, error, cargar } = useCargaLocal(() => getTiposBonoAsync(token));

  const getTiposBono = async () => {
    const result = await cargar();
    if (result) setTipoBonoList(result.data.result);
  };

  useEffect(() => {
    getTiposBono();
  }, []);

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      // Única regla de siempre: el monto no puede ir vacío. El tipo de bono lo exige el servidor
      // (B12, se propone aparte): aquí solo se explica si lo rechaza.
      if (monto.length === 0) return;

      const data = {
        employeeId: id,
        monto,
        desde: moment(desde).format("YYYY-MM-DD"),
        hasta: moment(hasta).format("YYYY-MM-DD"),
        tipoBonoId: selectedTBono,
      };

      const ok = await escribir(
        () => addBonoAsync(token, data),
        "No se pudo agregar el bono. Revisa que hayas elegido el tipo de bono."
      );
      if (!ok) return;
      aviso.exito("Bono agregado");
      setReload(!reload);
      setShowModal(false);
    });

  const setMontoBono = (montoBono) => {
    if (esMontoEscribible(montoBono)) {
      setMonto(montoBono);
    }
  };

  return (
    <DialogoFormulario
      titulo="Agregar bono"
      onCerrar={() => setShowModal(false)}
      hayCambios={
        monto !== "" || selectedTBono !== "" || fechaCambiada(desde) || fechaCambiada(hasta)
      }
      guardando={guardando}
      deshabilitado={cargando || Boolean(error)}
      onEnviar={saveChanges}
      textoEnviar="Agregar bono"
    >
      {error ? (
        <EstadoError
          titulo="No se pudieron cargar los tipos de bono"
          mensaje="Sin ellos no se puede agregar el bono. Revisa tu conexión e inténtalo de nuevo."
          onReintentar={getTiposBono}
        />
      ) : (
        <Grid container spacing={2} sx={{ pt: 1 }}>
          <Grid item xs={12}>
            <TextField
              select
              required
              fullWidth
              label="Tipo de bono"
              value={selectedTBono}
              onChange={(e) => setSelectedTBono(e.target.value)}
              helperText={cargando ? "Cargando los tipos de bono…" : " "}
              disabled={guardando || cargando}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de bono</em>
              </MenuItem>
              {tipoBonoList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.description}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CampoFecha
              label="Desde"
              value={desde}
              onChange={(newValue) => setDesde(newValue)}
              disabled={guardando}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CampoFecha
              label="Hasta"
              value={hasta}
              onChange={(newValue) => setHasta(newValue)}
              disabled={guardando}
            />
          </Grid>
          <Grid item xs={12}>
            <CampoMonto
              required
              label="Monto del bono"
              value={monto}
              onChange={setMontoBono}
              error={intentado && monto.length === 0 ? "Ingrese el monto del bono" : ""}
              disabled={guardando}
            />
          </Grid>
        </Grid>
      )}
    </DialogoFormulario>
  );
};

export default AddBono;
